export default __webpack_public_path__ + "static/12-1--b06a9d40a40aacd241ec63d3ee679bae.png";